module.exports = __webpack_public_path__ + "static/media/logo_finger_print.46be1575.png";